var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDataFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 233,
    viewBox: "0 0 350 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.662 130.453L92.026 159.281C92.2053 159.899 91.849 160.545 91.2301 160.724C91.1246 160.755 91.0153 160.77 90.9054 160.77H74.1774C73.5331 160.77 73.0107 160.248 73.0107 159.605C73.0107 159.495 73.0263 159.386 73.0568 159.281L81.4208 130.453C81.6001 129.835 82.2472 129.48 82.8661 129.659C83.2503 129.77 83.5507 130.07 83.662 130.453Z",
    fill: "#D0D0D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.5417 129.504L92.4583 160.77H72.625L82.5417 129.504Z",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.5415 132.05C82.5415 154.389 82.5415 165.807 82.5415 166.304C82.5415 165.807 82.5415 154.389 82.5415 132.05Z",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.2085 146.396C84.0974 150.16 82.5418 152.102 82.5418 152.221C82.5418 152.102 84.0974 150.16 87.2085 146.396Z",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.128 113.005L114.846 162.184C115.031 162.8 114.68 163.449 114.062 163.634C113.954 163.666 113.841 163.683 113.728 163.683H86.5275C85.8832 163.683 85.3608 163.161 85.3608 162.518C85.3608 162.405 85.3773 162.292 85.4097 162.184L100.128 113.005Z",
    fill: "#D0D0D0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.042 113.005L115.208 163.683H84.875L100.042 113.005Z",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.042 114.512C100.042 148.553 100.042 166.011 100.042 166.886C100.042 166.011 100.042 148.553 100.042 114.512Z",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.7114 137.47C97.6003 141.593 99.5448 143.729 99.5448 143.878C99.5448 143.729 97.6003 141.593 93.7114 137.47Z",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.711 152.615C106.156 146.253 108.878 143.147 108.878 143.295C108.878 143.147 106.156 146.253 100.711 152.615Z",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M268.917 153.78L241.208 131.645L221.958 146.79",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M227.5 141.548L221.958 136.888L203 152.615",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.811 168.322C130.215 164.565 126.551 161.937 122.286 161.937C121.111 161.937 119.982 162.136 118.929 162.504C116.93 159.413 113.498 157.374 109.599 157.374C105.87 157.374 102.568 159.239 100.538 162.106C99.7261 161.625 98.783 161.35 97.777 161.35C96.8965 161.35 96.0642 161.561 95.3258 161.936C93.3319 156.743 88.3807 153.067 82.5886 153.067C77.2702 153.067 72.6609 156.166 70.3988 160.693C69.0615 160.052 67.5684 159.693 65.9932 159.693C60.9218 159.693 56.6999 163.409 55.7944 168.322H131.811Z",
    fill: "#D0D0D0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5835 167.469H125.417",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42 167.469H304.5",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.338 168.342H200.896C200.858 167.913 200.838 167.479 200.838 167.04C200.838 159.178 207.13 152.806 214.892 152.806C217.025 152.806 219.047 153.287 220.858 154.148C223.921 148.071 230.163 143.909 237.365 143.909C245.208 143.909 251.913 148.845 254.613 155.816C255.613 155.313 256.74 155.03 257.932 155.03C259.295 155.03 260.572 155.399 261.671 156.045C264.42 152.196 268.892 149.692 273.941 149.692C281.363 149.692 287.537 155.102 288.825 162.239C289.206 162.178 289.596 162.147 289.993 162.147C293.656 162.147 296.703 164.818 297.338 168.342Z",
    fill: "#D0D0D0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M219.917 167.469H302.167",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.958 146.499H215.542V138.344H150.792V146.499H177.625V158.731H193.958V146.499Z",
    fill: "#D0D0D0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M151.083 138.052H123.083V146.207H151.083V138.052Z",
    fill: "#D0D0D0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.515 146.473V158.832H193.623L194.147 146.867L215.542 146.473V177.954H151.375V146.611L177.515 146.473Z",
    fill: "#D0D0D0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M151.375 146.499H123.375V177.954H151.375V146.499Z",
    fill: "#D0D0D0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.375 138.344H215.542V177.954H151.375V138.344Z",
    stroke: "#616161",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.542 146.499V138.344H151.375V146.499H177.625V158.731H193.958V146.499H215.542Z",
    stroke: "#616161",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.625 124.364C107.625 132.085 113.893 138.344 121.625 138.344H127.458V110.384H121.625C113.893 110.384 107.625 116.643 107.625 124.364Z",
    fill: "#D0D0D0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.864 112.989C116.33 112.715 111.379 115.83 108.014 122.335C107.803 122.742 107.606 123.118 107.425 123.463L107.98 120.459C108.195 119.951 108.553 119.115 109.052 117.95C111.834 114.642 113.323 112.989 113.52 112.989C113.717 112.989 115.075 112.255 117.594 110.788L120.347 110.353H122.864V112.989Z",
    fill: "#D0D0D0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.625 124.364C107.625 132.085 113.893 138.344 121.625 138.344H127.458V110.384H121.625C113.893 110.384 107.625 116.643 107.625 124.364Z",
    stroke: "#616161",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.375 110.384H187.542V138.344H123.375V110.384Z",
    fill: "#D0D0D0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.375 110.384H187.542V138.344H123.375V110.384Z",
    stroke: "#616161",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M151.375 146.499H123.375V177.954H151.375V146.499Z",
    stroke: "#616161",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M151.375 138.344H123.375V146.499H151.375V138.344Z",
    stroke: "#616161",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189 148.537C189 150.148 187.696 151.45 186.083 151.45C184.47 151.45 183.167 150.148 183.167 148.537C183.167 146.927 184.47 145.625 186.083 145.625C187.696 145.625 189 146.927 189 148.537Z",
    fill: "#616161"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M186.083 150.285V153.197",
    stroke: "#616161",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M156.917 153.78C157.883 153.78 158.667 152.998 158.667 152.032C158.667 151.067 157.883 150.285 156.917 150.285C155.95 150.285 155.167 151.067 155.167 152.032C155.167 152.998 155.95 153.78 156.917 153.78Z",
    fill: "#616161"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M156.917 174.168C157.883 174.168 158.667 173.385 158.667 172.42C158.667 171.455 157.883 170.673 156.917 170.673C155.95 170.673 155.167 171.455 155.167 172.42C155.167 173.385 155.95 174.168 156.917 174.168Z",
    fill: "#616161"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M210 153.78C210.966 153.78 211.75 152.998 211.75 152.032C211.75 151.067 210.966 150.285 210 150.285C209.034 150.285 208.25 151.067 208.25 152.032C208.25 152.998 209.034 153.78 210 153.78Z",
    fill: "#616161"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M210 174.168C210.966 174.168 211.75 173.385 211.75 172.42C211.75 171.455 210.966 170.673 210 170.673C209.034 170.673 208.25 171.455 208.25 172.42C208.25 173.385 209.034 174.168 210 174.168Z",
    fill: "#616161"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M145.833 153.78C146.8 153.78 147.583 152.998 147.583 152.032C147.583 151.067 146.8 150.285 145.833 150.285C144.867 150.285 144.083 151.067 144.083 152.032C144.083 152.998 144.867 153.78 145.833 153.78Z",
    fill: "#616161"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M145.833 174.168C146.8 174.168 147.583 173.385 147.583 172.42C147.583 171.455 146.8 170.673 145.833 170.673C144.867 170.673 144.083 171.455 144.083 172.42C144.083 173.385 144.867 174.168 145.833 174.168Z",
    fill: "#616161"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M128.917 153.78C129.883 153.78 130.667 152.998 130.667 152.032C130.667 151.067 129.883 150.285 128.917 150.285C127.95 150.285 127.167 151.067 127.167 152.032C127.167 152.998 127.95 153.78 128.917 153.78Z",
    fill: "#616161"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M128.917 174.168C129.883 174.168 130.667 173.385 130.667 172.42C130.667 171.455 129.883 170.673 128.917 170.673C127.95 170.673 127.167 171.455 127.167 172.42C127.167 173.385 127.95 174.168 128.917 174.168Z",
    fill: "#616161"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.375 166.186L235.083 177.965H224.583L229.292 166.186C229.411 165.887 229.751 165.741 230.05 165.861C230.198 165.92 230.316 166.037 230.375 166.186Z",
    fill: "#616161"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.5 170.564L239.458 177.965H232.458L235.417 170.564C235.536 170.265 235.876 170.119 236.175 170.239C236.323 170.298 236.441 170.415 236.5 170.564Z",
    fill: "#616161"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.667 166.186L109.958 177.965H120.458L115.75 166.186C115.631 165.887 115.291 165.741 114.992 165.861C114.844 165.92 114.726 166.037 114.667 166.186Z",
    fill: "#616161"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.042 170.564L102.083 177.965H109.083L106.125 170.564C106.006 170.265 105.666 170.119 105.367 170.239C105.219 170.298 105.101 170.415 105.042 170.564Z",
    fill: "#616161"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M271.25 177.954H278.25",
    stroke: "#616161",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M61.25 177.954H265.417",
    stroke: "#616161",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M119 83.5887H130.083C129.663 80.4272 130.714 77.7823 133.238 75.6542C136.136 73.2811 139.576 73.8131 141.424 74.632C143.272 75.4508 144.644 76.5759 145.595 78.6988C145.998 79.5926 146.272 80.3489 146.417 80.9675",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M141.75 85.3363C142.366 83.2079 143.63 81.8164 145.542 81.1616C148.41 80.1795 151.13 81.4874 152.216 82.8035C153.303 84.1195 153.647 85.1767 153.852 86.28C153.989 87.0155 154.038 87.8659 154 88.8313C156.416 88.733 158.036 89.2184 158.86 90.2875C159.857 91.5653 159.959 93.0938 159.596 94.2194C159.233 95.345 158.022 96.9863 155.75 96.9863H109.667",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M103.833 89.4137H141.75",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3335 89.4137H98.0002",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M183.75 65.5312H194.833C194.413 62.3697 195.464 59.7248 197.988 57.5967C200.886 55.2236 204.326 55.7556 206.174 56.5745C208.022 57.3933 209.394 58.5184 210.345 60.6413C210.748 61.5351 211.022 62.2914 211.167 62.91",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 67.2787C207.116 65.1504 208.38 63.7589 210.292 63.1041C213.16 62.122 215.88 63.4299 216.966 64.746C218.053 66.062 218.397 67.1192 218.602 68.2225C218.739 68.958 218.788 69.8084 218.75 70.7737C221.166 70.6755 222.786 71.1609 223.61 72.23C224.607 73.5078 224.709 75.0363 224.346 76.1619C223.983 77.2875 222.772 78.9287 220.5 78.9287H174.417",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M168.583 71.3562H206.5",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M158.083 71.3562H162.75",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M254.631 98.8363C254.631 98.8363 260.342 99.8266 258.864 105.6",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M267.03 104.18C267.03 104.18 262.733 100.297 259.086 105.014",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M239.872 120.342C239.872 120.342 244.832 117.349 247.51 122.674",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M253.176 116.782C253.176 116.782 247.381 116.666 247.728 122.616",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M188.708 97.2775V106.015",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M194.833 112.714H203.583",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M193.083 108.054L200.083 101.646",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataFound);
export default __webpack_public_path__ + "static/media/no_data_found.8e29a179ab85782c7c24cb3c5b465ad0.svg";
export { ForwardRef as ReactComponent };